export default __webpack_public_path__ + "static/media/chromatics.3b43a33d.png";